import request from '@/utils/request'

export function fetchCorrectList(query) {
    return request({
        url: '/correct/corrects',
        method: 'get',
        params: query
    })
}

export function createCorrect(data) {
    return request({
        url: '/correct/corrects',
        method: 'post',
        data
    })
}

export function fetchCorrectDetail(id) {
    return request({
        url: '/correct/correct/' + id,
        method: 'get'
    })
}

export function UpdateCorrectDetail(id, data) {
    return request({
        url: '/correct/correct/' + id,
        method: 'put',
        data
    })
}

export function SubmitCorrect(id) {
    return request({
        url: '/correct/submit/' + id,
        method: 'post',
    })
}

export function CheckCorrect(data) {
    return request({
        url: '/correct/check',
        method: 'post',
        data
    })
}

export function SendCorrect(data) {
    return request({
        url: '/correct/send',
        method: 'post',
        data
    })
}

export function ExportCorrect(id) {
    return request({
        url: '/correct/export/' + id,
        method: 'post',
        responseType: 'blob',
        headers: {
        'Content-Type': 'application/json'
        }
    })
}

export function deleteCorrectDetail(id) {
    return request({
        url: '/correct/correct/' + id,
        method: 'delete'
    })
}

export function getShipOrCustomerList(data) {
    return request({
        url: '/correct/get-list',
        method: 'post',
        data
    })
}

export function searchList(query) {
    return request({
        url: '/correct/get-list',
        method: 'get',
        params: query
    })
}